import { FC } from "react";
import InfoTileContainer from "../../../../../shared-elements/info-tile/info-tile-container.component";
import InfoTileComponent from "../../../../../shared-elements/info-tile/info-tile.component";

interface DeviceStatisticsSectionProps {
  deviceStatusCountData: any;
  isLoadingDeviceStatusCount: boolean;
}

const DeviceStatisticsSection: FC<DeviceStatisticsSectionProps> = ({
  deviceStatusCountData,
  isLoadingDeviceStatusCount,
}) => {
  return (
    <div
      className="my-4 dashboard-card-grid"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(49%, 1fr))",
        gridGap: "1rem",
      }}
    >
      <InfoTileContainer header="Device Status Info">
        <InfoTileComponent
          title="Total Devices"
          value={deviceStatusCountData?.totalDevices || 0}
          isLoading={isLoadingDeviceStatusCount}
        />

        <InfoTileComponent
          title="Online Devices"
          value={deviceStatusCountData?.onlineDevices || 0}
          isLoading={isLoadingDeviceStatusCount}
        />

        <InfoTileComponent
          title="Offline Devices"
          value={deviceStatusCountData?.offlineDevices || 0}
          isLoading={isLoadingDeviceStatusCount}
        />
      </InfoTileContainer>
    </div>
  );
};

export default DeviceStatisticsSection;
